import { Box, Button, Stack, Typography } from "@mui/material";
import { useContext, useEffect } from "react";
import styled from "styled-components";
import { computeScale } from "../../../constants/utils";
import { GameContext, IGameContext } from "../../../contexts/GameContext";
import AnimationPlayer from "../Results/AnimationPlayer";
import ComfortBar from "../Results/ComfortBar";
import QualityBar from "../Results/QualityBar";
import Analysis from "./Analysis";
import FinalScore from "./FinalScore";
import { computeFinalAvg, computeFinalCumulAvg, computeFinalScore } from "../../../interface/Util";
import { AppContext } from "../../../contexts/AppContext";
import { setStyle } from "../../../util";
import { GameState } from "../../../interface/GameState";
import { EquationsService } from "../../../services/equations/equationService";


interface Props {
  nextPageFn: () => void,
}

const GameResults = ({ nextPageFn }: Props) => {
  const { beginTime, maxPoints, finalScores, values, results, points, interfaceParams, bounds, maxRound, setStartAt,setData, setGameState, setScores, setPoints, setTime, setResults, setCurrentStep, setRound,setFinalScores, setGameId  } = useContext<IGameContext>(GameContext);

  const { defaultValues, store, connectSocket ,jwtToken} = useContext(AppContext);

  useEffect(() => {
      if (defaultValues) setStyle(defaultValues);
  })

  async function handleFinish(){
    if(store==""){
      setGameState(GameState.REWARD)
    }else{
      if(jwtToken){
        const configResponse = await EquationsService.getGameConfigFile(jwtToken);
        if (configResponse.status === 200){
          const gameConfig = configResponse.data;
          setData(gameConfig.default[0]);
        }
      }
      
      setFinalScores([])
      setCurrentStep(0);
      setResults([{ "timestamps": [], "score": 0 }])
      setTime(beginTime[0]);
      setPoints(maxPoints[0]);
      setScores([[]])
      setRound(0);
      setStartAt(new Date())
      setGameId(crypto.randomUUID())
      await connectSocket()
      
      setGameState(GameState.ROUND)
    }
  }
  
  return (
    <Container className="wrapper-resultat final-results">
      <Box className="wrapper-top-panel">
        <Box className="container-top">
          <Box className="container-top-left">
            <Typography sx={{ m: 4, fontWeight: 'bold' }} variant="h5">Résultats du jeu</Typography>
          </Box>
          <Box className="container-top-right">
            <Box className="box-result">
              <Box className="container-result">
               <FinalScore finalScore={computeFinalScore(finalScores)} scores={finalScores} />
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
      <Body className="container-resultat">

        <MainWindow className="main-resultat">

          
            

            <Row className="box-result">
              <Title className="main-resultat-title">Confort</Title>
              <Box className="box-result-stat">
                <StatBox>
                  <AnimationPlayer asset={"air_quality"} caption={"Qualité de l'air"} isGameEnd={true} />
                  {interfaceParams && results[0] ? <QualityBar
                    lowThreshold={interfaceParams["bars"]["air_quality"]["gradient"][1]["threshold"]}
                    highThreshold={interfaceParams["bars"]["air_quality"]["gradient"][2]["threshold"]}
                    currentScale={computeScale(computeFinalAvg(results, "air_quality", maxRound), bounds["air_quality"]["min"], bounds["air_quality"]["max"])}
                    minLabel={interfaceParams["bars"]["air_quality"]["labels"][0]}
                    maxLabel={interfaceParams["bars"]["air_quality"]["labels"][1]}
                    asset={"air_quality"}
                  /> : null}
                </StatBox>

                <StatBox>
                  <AnimationPlayer asset={"visual_comfort"} caption={"Confort visuel"} isGameEnd={true} />
                  {interfaceParams && results[0] ? <ComfortBar
                    lowerThreshold={interfaceParams["bars"]["visual_comfort"]["gradient"][1]["threshold"]}
                    lowThreshold={interfaceParams["bars"]["visual_comfort"]["gradient"][2]["threshold"]}
                    highThreshold={interfaceParams["bars"]["visual_comfort"]["gradient"][3]["threshold"]}
                    higherThreshold={interfaceParams["bars"]["visual_comfort"]["gradient"][4]["threshold"]}
                    currentScale={computeScale(computeFinalAvg(results, "visual_comfort", maxRound), bounds["visual_comfort"]["min"], bounds["visual_comfort"]["max"])}
                    minLabel={interfaceParams["bars"]["visual_comfort"]["labels"][0]}
                    maxLabel={interfaceParams["bars"]["visual_comfort"]["labels"][1]}
                    asset={"visual_comfort"}
                  /> : null}
                </StatBox>

                <StatBox>
                  <AnimationPlayer asset={"thermal_comfort"} caption={"Confort thermique"} isGameEnd={true} />
                  {interfaceParams && results[0] ? <ComfortBar
                    lowerThreshold={interfaceParams["bars"]["thermal_comfort"]["gradient"][1]["threshold"]}
                    lowThreshold={interfaceParams["bars"]["thermal_comfort"]["gradient"][2]["threshold"]}
                    highThreshold={interfaceParams["bars"]["thermal_comfort"]["gradient"][3]["threshold"]}
                    higherThreshold={interfaceParams["bars"]["thermal_comfort"]["gradient"][4]["threshold"]}
                    currentScale={computeScale(computeFinalAvg(results, "thermal_comfort", maxRound), bounds["thermal_comfort"]["min"], bounds["thermal_comfort"]["max"])}
                    minLabel={interfaceParams["bars"]["thermal_comfort"]["labels"][0]}
                    maxLabel={interfaceParams["bars"]["thermal_comfort"]["labels"][1]}
                    asset={"thermal_comfort"}
                  /> : null}
                </StatBox>
              </Box>
            </Row>
          

          <Row className="box-result">
            <Title className="main-resultat-title">Performance énergétique</Title>
            <Box className="box-result-stat">
              <StatBox>
                <AnimationPlayer asset={"energy"} caption={"Consommation d'énergie"} isGameEnd={true} />
                {interfaceParams && results[0] ? <QualityBar
                  lowThreshold={interfaceParams["bars"]["energy"]["gradient"][1]["threshold"]}
                  highThreshold={interfaceParams["bars"]["energy"]["gradient"][2]["threshold"]}
                  currentScale={computeScale(computeFinalAvg(results, "energy", maxRound), bounds["energy"]["min"], bounds["energy"]["max"])}
                  minLabel={interfaceParams["bars"]["energy"]["labels"][0]}
                  maxLabel={interfaceParams["bars"]["energy"]["labels"][1]}
                  asset="energy"
                /> : null}
              </StatBox>

              <StatBox>
                <AnimationPlayer asset={"cost"} caption={"Coûts"} isGameEnd={true} />
                {interfaceParams && results[0] ? <QualityBar
                  lowThreshold={interfaceParams["bars"]["cost"]["gradient"][1]["threshold"]}
                  highThreshold={interfaceParams["bars"]["cost"]["gradient"][2]["threshold"]}
                  currentScale={computeScale(computeFinalCumulAvg(results, "cost", maxRound), bounds["cost"]["min"], bounds["cost"]["max"])}
                  minLabel={interfaceParams["bars"]["cost"]["labels"][0]}
                  maxLabel={interfaceParams["bars"]["cost"]["labels"][1]}
                  asset="cost"
                /> : null}
              </StatBox>
            </Box>
          </Row>

        </MainWindow>

        <Stack className="container-analysis">
          {/*
          <Analysis values={values} points={points} finalScores={finalScores} />
          */}
          <Button variant="contained" onClick={()=>{handleFinish()}}>{store==""?"Choisir ma carte cadeau":"Refaire une simuation"}</Button>
        </Stack>

      </Body>
    </Container>
  );
};


const Container = styled.div`
`;


const Body = styled.div`
    display: flex;
`


const MainWindow = styled.div`
`;

const Title = styled.div`
    display: flex;
    color: white;
    padding: .5em;
`;

const Row = styled.div`
    display: flex;
`;

const StatBox = styled.div`
    
`;


export default GameResults;